module.exports = __webpack_public_path__ + "static/media/absolute_white.60f7bce4.svg";